export const initialState = {
    ripsDetail: {
        header: {},
        body: null,
        errorAlert: {
            isAxiosError: false
        },
        loading: false
    },
    ripsResult: {
        body: {
            validationResults: []
        },
        errorAlert: {
            isAxiosError: false
        },
        loading: false
    },
    dashboardUrl: {
        body: null,
        errorAlert: {
            isAxiosError: false
        },
        loading: false
    }
}

export default {
    ...initialState
}